import DefaultLayout from '@components/layout/layout/DefaultLayout';
import VideoResource from './VideoResource';

const FsmHowToApply = () => (
  <DefaultLayout>
    <VideoResource
      title="Applying for Medicare Parts A & B"
      buttonLabel="Sign Up For Parts A & B"
      href="https://secure.ssa.gov/iClaim/rib"
      videoURL="https://www.youtube.com/embed/VtdPS9pkVqg"
    />
  </DefaultLayout>
);

export default FsmHowToApply;
